import { useState, useEffect, useLayoutEffect, useRef, CSSProperties } from "react";
import ChartCanvas from './ChartCanvas'
import { EChartsOption } from "echarts";
import { Title, Loading } from "../Layouts";

export default function OnlineRatioAxis(p: { orgReport?: OrgReport, loading: boolean, orgId: any, style: CSSProperties }) {
    const [options, setOptions] = useState<EChartsOption>();
    const data = p.orgReport?.projectReportInfoList;
    const titleRef = useRef<HTMLDivElement>(null);
    const [hover, setHover] = useState(false);
    const [canvasHeight, setCanvasHeight] = useState((p.style.height as number) - 27.5);
    const [pagination, setPagination] = useState({
        start: 0,
        end: 4
    });
    useEffect(() => {
        if (!data) return;
        const baseOptions: EChartsOption = {
            backgroundColor: 'rgb(9, 53, 99)',
            color: ['rgb(248, 151, 71)', 'rgb(82, 196, 26)'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
            },
            legend: {
                show: true,
            },
            grid: {
                top: '20%',
                bottom: '20%',
                left: '10%',
                right: '10%',
            },
            yAxis: {
                type: 'value',
                splitLine: {
                    show: false
                }
            },
        };
        const { start, end } = pagination;
        // const dataSlice = data?.slice(start, end) || [];
        const dataSlice = data || [];
        const option: EChartsOption = {
            ...baseOptions,
            xAxis: {
                type: 'category',
                data: dataSlice.map(i => i.project.name),
            },
            series: [
                {
                    data: dataSlice.map(i => i.offlineCount),
                    type: 'bar',
                    stack: 'count',
                    name: '离线设备',
                    // barWidth: 20,
                },
                {
                    data: dataSlice.map(i => i.onlineCount),
                    type: 'bar',
                    stack: 'count',
                    name: '在线设备',
                    label: {
                        show: true,
                        position: 'top',
                        formatter: ({dataIndex}) =>  {
                            const record = dataSlice[dataIndex];
                            return `${record.deviceCount}`;
                        }
                    }
                },
            ]
        };
        setOptions(option as any);

    }, [data, pagination]);
    useEffect(() => {
        return
        if (data?.length === 0 || hover) return;
        const timer = setTimeout(() => {
            const { start, end } = pagination;
            const isEnd = end >= (data?.length || 0);
            setPagination(isEnd ? {
                start: 0,
                end: 4,
            } : {
                start: start + 1,
                end: end + 1
            })
        }, 1000);
        return () => {
            clearTimeout(timer)
        }
    }, [pagination, data, hover]);

    useLayoutEffect(() => {
        if (titleRef.current) {
            setCanvasHeight((p.style.height as number) - titleRef.current.clientHeight)
        }
    }, [p.style.height])
    return <div style={{ ...p.style }} onMouseEnter={() => {
        setHover(true)
    }}
        onMouseLeave={() => {
            setHover(false)
        }}
    >
        <Title ref={titleRef}>展会设备统计</Title>
        {
            p.loading ?
                <div style={{
                    width: p.style.width, height: canvasHeight,
                    background: 'rgb(9, 53, 99)'
                }}>
                    <Loading />
                </div> :
                <ChartCanvas options={options} styles={{
                    width: p.style.width, height: canvasHeight
                }} />
        }

    </div>
}